var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component } from 'vue-property-decorator';
import GlobalVue from '../../globalVue';
import OrderService from '../../api/OrderService';
import MulShopOamount from './MulShopOamount.vue';
import { summaries } from '../../helper/util';
import { numAdd, numMulti } from '../../helper/calucate';
import ELogisticsType from '../../enum/ELogisticsType';
import { UrlHelper } from '../../helper/UrlWrapper';
import { Loading } from 'element-ui';
import { EPurOrderErrorCode } from '../../enum/EPurchaseOrderCode';
import EOrderFromSystem from '../../enum/EOrderFromSystem';
import Purchase from '../purchase/List.vue';
import Client from '../client/List.vue';
import ArticleList from '../../components/alert/ArticleList.vue';
var PurOrderShip = (function (_super) {
    __extends(PurOrderShip, _super);
    function PurOrderShip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.orderRowId = null;
        _this.organRowId = null;
        _this.depotRowId = null;
        _this.listData = [];
        _this.tableHeight = 300;
        _this.billData = {};
        _this.dialogTableVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = '';
        _this.mulShopList = [];
        _this.eLogisticsType = ELogisticsType;
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = '';
        _this.userList = [];
        _this.eOrderFromSystem = EOrderFromSystem;
        return _this;
    }
    PurOrderShip.prototype.created = function () {
        this.service = OrderService.getInstance();
        this.getGoodList();
        this.getUserList();
    };
    PurOrderShip.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 260;
        }, 300);
    };
    PurOrderShip.prototype.tableRowClassName = function (data) {
        if (!this.openedCodeData.isOpenERP)
            return;
        if (data.row.out_storage_amount > data.row.current_stock) {
            if (data.columnIndex == 0) {
                return 'success-row-t-b-l';
            }
            else if (data.columnIndex == 12) {
                return 'success-row-t-b-r';
            }
            else {
                return 'success-row-t-b';
            }
        }
        else {
            return 'warning-row';
        }
    };
    PurOrderShip.prototype.calc_outStorageAmount = function (row, type) {
        return (row[type] = numMulti(row.order_detail_oamount, row.sales_unit_coefficient));
    };
    PurOrderShip.prototype.getGoodList = function () {
        var _this = this;
        var params = {
            order_id: this.orderRowId,
            is_delivery: 1,
        };
        if (this.openedCodeData.isOnlyOpenERP) {
            Object.assign(params, {
                depot_id: this.depotRowId,
                organ_id: this.organRowId,
            });
        }
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service
            .getDeliveryGoodList(params)
            .then(function (res) {
            loadingInstance.close();
            if (res.data.code == 0) {
                var data = res.data.data;
                _this.billData = data;
                _this.listData = data.items;
                _this.isEditAmount = data.is_modify_oamount == 1;
                _this.isEditUprice = data.is_show_uprice == 1 && data.is_modify_uprice == 1;
                return;
            }
            var instance = _this.$dialog(ArticleList, {
                data: {
                    resData: res.data,
                },
            }, {
                title: '提示',
                width: 450,
                height: 350,
                closeBtn: false,
            }).instance;
            instance.$on('addClient:ok', function (data) {
                if (res.data.code == EPurOrderErrorCode.BUSINESS_GOODS_NOT_BIND) {
                    GlobalVue.$emit('addTab', {
                        component: Client,
                        title: '合作客户',
                        name: '合作客户',
                        showExist: true,
                        cprops: {},
                    });
                }
                else if (res.data.code == EPurOrderErrorCode.GOODS_STOCK_IS_SHORT) {
                    GlobalVue.$emit('addTab', {
                        component: Purchase,
                        title: '采购入库',
                        showExist: true,
                        name: '采购入库',
                        cprops: {},
                    });
                }
                GlobalVue.$emit('closeTab', _this);
            });
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    PurOrderShip.prototype.getUserList = function () {
        var _this = this;
        this.service.getUserList().then(function (res) {
            console.log(res);
            _this.userList = res.data.data || [];
        });
    };
    PurOrderShip.prototype.sendGoods = function () {
        var _this = this;
        var diffList = this.listData.filter(function (item) {
            return item.order_detail_amount > numAdd(item.order_detail_oamounted || 0, item.order_detail_oamount);
        });
        var msg = '请在确保货物发送后进行操作，以免遗漏业务';
        var cancleFun = function () { };
        var btn = {};
        this.$confirm(msg, '提示', btn).then(function (res) {
            var shipType = _this.ship(1, '2');
            shipType
                .then(function (res) {
                if (res.data.code == 0) {
                    _this.$message.success(res.data.msg);
                    GlobalVue.$emit('closeTab', _this);
                    if (_this.opener && _this.opener.fromPage == 'list') {
                        _this.opener.search();
                    }
                    else if (_this.opener && _this.opener.fromPage == 'detail') {
                        _this.opener.getGoodList();
                    }
                    return;
                }
                var instance = _this.$dialog(ArticleList, {
                    data: {
                        resData: res.data,
                    },
                }, {
                    title: '提示',
                    width: 450,
                    height: 350,
                    closeBtn: false,
                }).instance;
                instance.$on('addClient:ok', function (data) {
                    if (res.data.code == EPurOrderErrorCode.BUSINESS_GOODS_NOT_BIND) {
                        GlobalVue.$emit('addTab', {
                            component: Client,
                            title: '合作客户',
                            name: '合作客户',
                            showExist: true,
                            cprops: {},
                        });
                    }
                    else if (res.data.code == EPurOrderErrorCode.GOODS_STOCK_IS_SHORT) {
                        GlobalVue.$emit('addTab', {
                            component: Purchase,
                            title: '采购入库',
                            showExist: true,
                            name: '采购入库',
                            cprops: {},
                        });
                    }
                    GlobalVue.$emit('closeTab', _this);
                });
            }, function (err) {
                _this.$message.error(err.message || err.msg);
            })
                .catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }, function (action) {
            if (action == 'cancel') {
                cancleFun();
            }
        });
    };
    PurOrderShip.prototype.save = function () {
        var _this = this;
        this.$confirm('是否要暂存?', '提示', {}).then(function (res) {
            _this.ship(2)
                .then(function (res) {
                _this.$message.success(res.data.msg);
                window._czc.push(['_trackEvent', '客户订单发货', '保存']);
            }, function (err) {
                _this.$message.error(err.message || err.msg);
            })
                .catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        });
    };
    PurOrderShip.prototype.ship = function (type, shipType) {
        var _this = this;
        var promise = new Promise(function (resolve, reject) {
            var params = {
                order_id: _this.billData.order_id,
                deliverer: _this.billData.deliverer,
                deliverer_phone: _this.billData.deliverer_phone,
                reciever_phone: _this.billData.reciever_phone,
                reciever_address: _this.billData.reciever_address,
                data: JSON.stringify(_this.listData),
                type: type,
                delivery_status: shipType,
            };
            if (!_this.openedCodeData.isOpenSorting) {
                Object.assign(params, {
                    depot_id: _this.depotRowId,
                });
            }
            var loadingInstance = Loading.service({ fullscreen: true });
            _this.service
                .ship(params)
                .then(function (res) {
                resolve(res);
                loadingInstance.close();
                if (res.data.code != 0) {
                    return;
                }
                if (params.type == 1) {
                    window._czc.push(['_trackEvent', '客户订单发货', '发货', '发货成功']);
                }
                if (params.type == 2) {
                    window._czc.push(['_trackEvent', '客户订单发货', '保存']);
                }
            }, function (err) {
                if (params.type == 1) {
                    window._czc.push(['_trackEvent', '客户订单发货', '发货', '发货失败']);
                }
                reject(err);
                loadingInstance.close();
            })
                .catch(function (err) {
                reject(err);
                loadingInstance.close();
            });
        });
        return promise;
    };
    PurOrderShip.prototype.batchEdit = function () {
        if (!this.isEditAmount) {
            this.$confirm('该客户不支持修改发货信息', '提示', {
                customClass: 'confirm',
                showCancelButton: false,
                confirmButtonText: '知道了',
            });
            return;
        }
        this.dialogTableVisible = true;
        this.setUploadType('beford');
    };
    PurOrderShip.prototype.exportGoods = function () {
        var url = 'supplierclientapi/purchaseorder/batch_modify_delivery?order_id=' + this.billData.order_id;
        url = UrlHelper.addParam(url, 'token', this.user.token);
        location.href = url;
    };
    PurOrderShip.prototype.befordUpload = function (file) {
        var name = file.name.split('.'), fileType = name[name.length - 1];
        if (!(fileType && (fileType == 'xlsx' || fileType == 'xls'))) {
            this.$message.error('文件只能是xlsx或xls');
            return false;
        }
        if (!this.loadingInstance)
            this.loadingInstance = Loading.service({ fullscreen: true });
    };
    PurOrderShip.prototype.uploadSuccess = function (response, file, fileList) {
        if (response.success) {
            this.responseSuccess = true;
            var data = response.data;
            this.importSuccessNum = data.success_num;
            this.importFailnum = data.error_num;
            var url = 'supplierclientapi/purchaseorder/batch_delivery_error?import_id=' + data.import_id;
            url = UrlHelper.addParam(url, 'token', this.user.token);
            this.failDownLoadUrl = url;
            this.getGoodList();
            window._czc.push(['_trackEvent', '客户订单发货', '批量修改导入']);
        }
        else {
            this.responseFail = true;
            this.errorMsg = response.msg || '网络异常，请重新导入';
            this.$message.error(response.msg);
        }
        this.uploadEnd(response);
    };
    PurOrderShip.prototype.uploadError = function (err, file, fileList) {
        this.responseFail = true;
        this.errorMsg = err.msg || err.message || '网络异常，请重新导入';
        this.uploadEnd();
    };
    PurOrderShip.prototype.uploadEnd = function (res) {
        if (!res.success && res.code && res.code == 9999) {
            this.responseFail = false;
            this.errorMsg = '';
            this.setUploadType('beford');
        }
        else {
            this.setUploadType('after');
        }
        this.loadingInstance.close();
    };
    PurOrderShip.prototype.uploadProgress = function (event, file, fileList) {
        this.setUploadType('importing');
    };
    PurOrderShip.prototype.setUploadType = function (type) {
        this.befordImport = type == 'beford';
        this.importting = type == 'importing';
        this.afterImport = type == 'after';
    };
    PurOrderShip.prototype.getSummaries = function (param) {
        var showSum = ['order_detail_amount', 'order_detail_oamount', 'total_price', 'order_detail_oamounted'];
        return summaries(param, showSum);
    };
    PurOrderShip.prototype.amountChange = function (row) {
        this.calTotal(row);
    };
    PurOrderShip.prototype.upriceChange = function (row) {
        this.calTotal(row);
    };
    PurOrderShip.prototype.calTotal = function (row) {
        if (!this.isEditAmount && row.order_detail_oamount == '') {
            return;
        }
        if (!this.isEditUprice && row.order_detail_uprice == '') {
            return;
        }
        row.total_price = numMulti(row.order_detail_oamount, row.order_detail_uprice);
    };
    PurOrderShip.prototype.mulShopOamountEdit = function (row) {
        this.mulShopList = JSON.parse(JSON.stringify(row.shop_items));
        this.$refs.mulShop.showRelease(row.goods_format_id);
        this.selectedRow = row;
    };
    PurOrderShip.prototype.shopAmountSave = function (listData) {
        var _this = this;
        var params = {
            order_id: this.orderRowId,
            data: JSON.stringify(listData),
        };
        this.service
            .shopAmountSubmit(params)
            .then(function (res) {
            _this.$refs.mulShop.close();
            var changeRow = res.data.data;
            _this.updateSelectRow(changeRow);
            _this.$message.success(res.data.msg || '保存成功');
        })
            .catch(function (err) {
            _this.$message.error(err.message || '保存失败');
        });
    };
    PurOrderShip.prototype.updateSelectRow = function (row) {
        this.selectedRow.order_detail_oamount = row.order_detail_oamount;
        this.selectedRow.shop_items = row.shop_items;
        this.amountChange(this.selectedRow);
    };
    PurOrderShip = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
                openedCodeData: 'openedCodeData',
                ediStatus: 'ediStatus',
            }), { isOrderMerge: function () {
                    var isStraight = this.billData.logistics_type == this.eLogisticsType.Straight;
                    var isVirtualStraight = this.billData.logistics_type == this.eLogisticsType.VirtualStraight;
                    var isDirectWhole = this.billData.logistics_type == this.eLogisticsType.Direct && this.billData.depot_in_type == 1;
                    if (isStraight || isVirtualStraight || isDirectWhole)
                        return true;
                    return false;
                } }),
            components: {
                'mul-shop-oamount': MulShopOamount,
            },
        })
    ], PurOrderShip);
    return PurOrderShip;
}(Vue));
export default PurOrderShip;
